import React from "react";
import "./assets/style.css";

const closeIcon = `${EASYCOMMERCE.assets}admin/img/icons/modal-close.png`;
const logo = `${EASYCOMMERCE.assets}common/img/logo.svg`;

const APIScreen = ({
    onClose,
    switchVariationModalTab,
    switchCreateModalTab,
}) => {
    return (
        <div className="fixed z-20 top-0 left-0 w-screen h-screen flex justify-center items-center bg-[#0000003B] backdrop-blur-sm">
            <div className="relative w-[548px] py-[60px] rounded-xl bg-white">
                <button className="absolute top-2 right-2" onClick={onClose}>
                    <img src={closeIcon} alt="close-icon" className="w-6 h-6" />
                </button>

                <div className="flex flex-col items-center gap-8">
                    <img
                        src={logo}
                        alt="easycommerce"
                        className="h-[52px]"
                    />

                    <div className="flex flex-col items-center gap-[30px]">
                        <div className="flex flex-col items-center gap-3">
                            <h2 className="text-[#120350] text-2xl font-inter font-semibold">
                                Connect with API Key
                            </h2>
                            <p className="w-[70%] mx-auto text-center text-ec-placeholder font-inter font-normal text-base">
                                An API key is required to integrate your store with our system, enabling seamless store management, one-click addon installation, and more.
                            </p>
                        </div>

                        <div className="w-[90%] flex justify-between items-center gap-4">
                            <button
                                className="w-full h-12 flex flrx-1 justify-center items-center font-medium font-inter text-base 
                                leading-[26px] text-white bg-ec-primary rounded-lg hover:bg-ec-secondary transition-all 
                                ease-in-out duration-300"
                                onClick={switchVariationModalTab}
                            >
                                Yes, I have an API key
                            </button>
                            <button
                                className="w-full h-12 flex flrx-1 justify-center items-center font-medium font-inter text-ec-primary 
                                hover:text-white text-base leading-[26px] bg-white hover:bg-ec-primary rounded-lg border 
                                border-ec-primary transition-all ease-in-out duration-300"
                                onClick={switchCreateModalTab}
                            >
                                No, I want an API key
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default APIScreen;
